import { FC } from "react";
import styles from "./SubscriptionItem.module.scss";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import {
  changeUserMailingSettings,
  getUserMailingSettings,
} from "@/entities/mailerSettings/slice";
import {
  IUserMailingSetting,
  MailingSettingsType,
  SubscriptionKey,
} from "@/entities/mailerSettings/type";
import { Checkbox } from "antd/lib";
import clsx from "clsx";
import { Tooltip } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";

interface SubscriptionItemProps {
  mailingType: SubscriptionKey;
  currentUser: IUserMailingSetting;
}
const getTitles = (mailingType: SubscriptionKey) => {
  switch (mailingType) {
    case "orderPd":
      return {
        title: "Оповещение о заявке на производство",
        secondText:
          "Оповещение о формировании заявки на производство будет осуществляться 1, 5 и 10-го числа каждого месяца",
      };

    case "salesAndRemainsWeekly":
      return {
        title: "О предоставлении отчёта о продажах и остатках",
        secondText: "По средам",
      };
    case "accountsReceivable":
      return {
        title: "О дебиторской задолженности",
        secondText:
          "Оповещение о наличии дебиторской задолженности формируется еженедельно по понедельникам",
      };
    case "pledgeBook":
      return {
        title: "О предоставлении книги залогов",
        secondText: "Оповещение формируется 1, 15-го числа каждого месяца",
      };
    case "salesAndRemainsMonthly":
      return {
        title: "О продажах по брендам и регионам",
        secondText: "Оповещение формируется 1, 15-го числа каждого месяца",
      };

    default:
      return {
        title: "",
        secondText: "",
      };
  }
};

export const SubscriptionItem: FC<SubscriptionItemProps> = ({
  mailingType,
  currentUser,
}) => {
  const dispatch = useAppDispatch();

  const { subscriptions } = useAppSelector((state) => state.mailing);

  const { title, secondText } = getTitles(mailingType);

  const clickHandler = async (
    type: keyof MailingSettingsType,
    value: boolean,
  ) => {
    const newParam = {
      ...currentUser,
      [type]: value,
    };
    if (type === "accountsReceivable") newParam.overdAccountsReceivable = value;

    await dispatch(changeUserMailingSettings(newParam));
    await dispatch(getUserMailingSettings(currentUser.userId));
  };

  const handleChange = (e: CheckboxChangeEvent) => {
    clickHandler(mailingType, e.target.checked);
  };

  const isLast =
    currentUser &&
    subscriptions[mailingType].length === 1 &&
    subscriptions[mailingType].some((sub) => sub.userId === currentUser.userId);

  if (!currentUser) {
    return;
  }

  return (
    <Tooltip
      overlayClassName={styles.customTooltip}
      overlayInnerStyle={{ backgroundColor: "#fff", color: "#8b8b8bff" }}
      placement="bottomLeft"
      title={
        isLast
          ? "Вы единственный участник рассылки, удаление из рассылки невозможно. Редактирование участников доступно вашему сотруднику с ролью в системе «Администратор» в профиле Дилера на вкладке «Рассылки»."
          : null
      }
    >
      <div className={styles.mainContainer}>
        <Checkbox
          disabled={isLast}
          checked={currentUser[mailingType]}
          className={clsx(styles.checboxCustom, {
            [styles.customHeight]: mailingType === "salesAndRemainsWeekly",
          })}
          onChange={handleChange}
        >
          <p className={styles.title}>{title}</p>
          {mailingType === "salesAndRemainsWeekly" && (
            <p className={styles.title}>Еженедельно</p>
          )}
        </Checkbox>
        <div className={styles.secondText}>{secondText}</div>
      </div>
    </Tooltip>
  );
};
